import { HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpRequest, HttpRequestClient } from 'src/app/client/core';
import { StringUtils } from './string.utils';

// @dynamic
export class ObjectUtils {
  public static isEmpty(parameter: any): boolean {
    return (
      parameter == null ||
      parameter === undefined ||
      (typeof parameter === 'string' && StringUtils.isEmpty(parameter))
    );
  }

  public static CreateObjectRequest<T extends HttpRequestClient>(
    http: T,
    request: HttpRequest
  ): Observable<any /*number | string*/> {
    return http.call(request).pipe(
      map((res: HttpResponse<any>) => {
        if (res.status >= 200 && res.status <= 299) {
          const headersLocation = res.headers.get('Location');
          // return Number(res.headers.get('x-id'));

          if (!headersLocation) {
            return null;
          }

          return headersLocation.split('/').pop();
        }
        throwError(/*new Error()*/ res.body);
        return undefined;
      })
    );
  }

  public static CreateObjectRequestWithLocation<T extends HttpRequestClient>(
    http: T,
    request: HttpRequest
  ): Observable<any /*number | string*/> {
    return http.call(request).pipe(
      map((res: HttpResponse<any>) => {
        if (res.status >= 200 && res.status <= 299) {
          const headersLocation = res.headers.get('Location');
          // return Number(res.headers.get('x-id'));

          if (!headersLocation) {
            return null;
          }
          let headers = headersLocation.split('/');
          return {
            id: headers.pop(),
            location: headers[headers.length - 1],
          };
        }
        throwError(/*new Error()*/ res.body);
        return undefined;
      })
    );
  }

  public static CreateObjectRequestWithCount<T extends HttpRequestClient>(
    http: T,
    request: HttpRequest
  ): Observable<any /*number | string*/> {
    return http.call(request).pipe(
      map((res: HttpResponse<any>) => {
        if (res.status >= 200 && res.status <= 299) {
          const headersCount = res.headers.get('x-count');
          // return Number(res.headers.get('x-id'));

          if (!headersCount) {
            return null;
          }
          let headers = headersCount.split('/');
          return {
            data: res.body,
            count: headers.pop(),
          };
        }
        throwError(/*new Error()*/ res.body);
        return undefined;
      })
    );
  }

  public static UpdateOrDeleteObjectRequest<T extends HttpRequestClient>(
    http: T,
    request: HttpRequest
  ): Observable<boolean> | Observable<any> {
    return http.call(request).pipe(
      map((res: HttpResponse<any>) => {
        if (res.status >= 200 && res.status <= 299) {
          return true;
        }
        throwError(/*new Error()*/ res.body);
        return false;
      })
    );
  }
}
